import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage, getImage, IGatsbyImageData, withArtDirection } from 'gatsby-plugin-image';

import { ImageBreakpoint, ImageDataLike, ImageProps, ResponsiveImage } from './models';
import { getArtDirectedImages } from './utils';

const defaultBreakpoints: ImageBreakpoint[] = [
  { alias: 'mobile', media: '(max-width: 500px)' },
  { alias: 'tablet', media: '(max-width: 1023px)' },
];

const Image: FC<ImageProps> = ({
  imageData,
  alt,
  breakpoints = defaultBreakpoints,
  ...restProps
}) => {
  if (!imageData) {
    return null;
  }

  const isArtDirected = Object.keys(imageData).includes('desktop');

  const mainImage = isArtDirected
    ? getImage((imageData as ResponsiveImage).desktop)
    : getImage(imageData as ImageDataLike);

  const images = withArtDirection(
    mainImage as IGatsbyImageData,
    getArtDirectedImages(breakpoints, imageData as ResponsiveImage)
  );

  return <GatsbyImage image={images} alt={alt} {...restProps} />;
};

export const createImageWithBreakpoints =
  (breakpoints: ImageBreakpoint[]): FC<ImageProps> =>
  (props: ImageProps) =>
    <Image {...props} breakpoints={breakpoints} />;

export const query = graphql`
  fragment ImageFragment on ResponsiveImage {
    desktop {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 100)
      }
    }
    tablet {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 100)
      }
    }
    mobile {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 100)
      }
    }
  }
`;

export default Image;
